import React from 'react';
import ButtonBase from './Button.base';

// import icons
import IconShare from 'js/components/icon/Icon.share';
import IconAdd from 'js/components/icon/Icon.add';
import IconTick from 'js/components/icon/Icon.tick';
import IconEdit from 'js/components/icon/Icon.edit';
import IconPrint from 'js/components/icon/Icon.print';
import IconLink from 'js/components/icon/Icon.link';
import IconDelete from 'js/components/icon/Icon.delete';
import IconSave from 'js/components/icon/Icon.save';
import IconDownload from 'js/components/icon/Icon.download';

const ICON_SET = {
  share: <IconShare />,
  add: <IconAdd />,
  tick: <IconTick />,
  edit: <IconEdit />,
  link: <IconLink />,
  print: <IconPrint />,
  delete: <IconDelete />,
  save: <IconSave />,
  download: <IconDownload />,
};

const ButtonWithIcon = ({
  title = '',
  backgroundColor = '#fff',
  iconName = false,
  iconPosition = 'left',
  action,
  animateTap,
  style = {},
  disabled = false,
}) => {
  return (
    <ButtonBase
      disabled={disabled}
      action={action}
      animateTap={animateTap}
      className={`button--with-icon button--icon-${iconPosition}`}
      style={{ backgroundColor, ...style }}
    >
      {iconName && ICON_SET[iconName] && iconPosition === 'left' && (
        <span className="button__icon">{ICON_SET[iconName]}</span>
      )}
      {title}
      {iconName && ICON_SET[iconName] && iconPosition === 'right' && (
        <span className="button__icon">{ICON_SET[iconName]}</span>
      )}
    </ButtonBase>
  );
};

export default ButtonWithIcon;
